import BaseReducer from "./BaseReducer";

class AlertModalReducer extends BaseReducer {
  domain = "Modals";
  type = "AlertModal";

  initialState = {
    open: false,
    title: "Confirmation",
    message: "Are you sure you wish to continue?",
  };
}

const reducer = new AlertModalReducer();

export default reducer;
